"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingOptions = exports.DUAL_DAO_WALLET_PK = exports.STAKING_OPTIONS_PK = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const anchor_1 = require("@project-serum/anchor");
const staking_options_idl_json_1 = __importDefault(require("./staking_options_idl.json"));
exports.STAKING_OPTIONS_PK = new web3_js_1.PublicKey('4yx1NJ4Vqf2zT1oVLk4SySBhhDJXmXFt88ncm4gPxtL7');
exports.DUAL_DAO_WALLET_PK = new web3_js_1.PublicKey('7Z36Efbt7a4nLiV7s5bY7J2e4TJ6V9JEKGccsy2od2bE');
/**
 * API class with functions to interact with the Staking Options Program using Solana Web3 JS API
 */
class StakingOptions {
    /**
     * Create a Staking Options object
     *
     * @param rpcUrl The solana cluster endpoint used for the connecton
     */
    constructor(rpcUrl, commitment = 'finalized') {
        this.commitment = commitment;
        this.connection = new web3_js_1.Connection(rpcUrl, this.commitment || 'finalized');
        const opts = {
            preflightCommitment: 'finalized',
            commitment: 'finalized',
        };
        // Public key and payer not actually needed since this does not send transactions.
        const wallet = {
            publicKey: exports.STAKING_OPTIONS_PK,
            signAllTransactions: (txs) => __awaiter(this, void 0, void 0, function* () { return txs; }),
            signTransaction: (tx) => __awaiter(this, void 0, void 0, function* () { return tx; }),
            payer: new web3_js_1.Keypair(),
        };
        const provider = new anchor_1.AnchorProvider(this.connection, wallet, opts);
        this.program = new anchor_1.Program(
        // @ts-ignore
        staking_options_idl_json_1.default, exports.STAKING_OPTIONS_PK, provider);
    }
    /**
     * Convert a number to bytes in the format that is used in ata seeds.
     */
    static toBeBytes(x) {
        const y = Math.floor(x / Math.pow(2, 32));
        return Uint8Array.from([y, y << 8, y << 16, y << 24, x, x << 8, x << 16, x << 24].map((z) => z >>> 24));
    }
    /**
     * Get the public key for the staking options state.
     */
    state(name, baseMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const [state, _stateBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('so-config')),
                Buffer.from(anchor_1.utils.bytes.utf8.encode(name)),
                baseMint.toBuffer(),
            ], this.program.programId);
            return state;
        });
    }
    /**
     * Get the state object for a staking options state.
     */
    getState(name, baseMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.state(name, baseMint);
            const stateObj = yield this.program.account.state.fetch(state, 'single');
            return stateObj;
        });
    }
    /**
     * Get the public key for a staking option mint. This is the option token mint.
     */
    soMint(strike, name, baseMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.state(name, baseMint);
            const [optionMint, _optionMintBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('so-mint')),
                state.toBuffer(),
                StakingOptions.toBeBytes(strike),
            ], this.program.programId);
            return optionMint;
        });
    }
    /**
     * Get the public key for a staking option vault. This is where the base tokens
     * are stored.
     */
    baseVault(name, baseMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const [baseVault, _baseVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('so-vault')),
                Buffer.from(anchor_1.utils.bytes.utf8.encode(name)),
                baseMint.toBuffer(),
            ], this.program.programId);
            return baseVault;
        });
    }
    /**
     * Get the public key for where fees are accrued.
     */
    static getFeeAccount(mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeAccount = yield (0, spl_token_1.getAssociatedTokenAddress)(mint, exports.DUAL_DAO_WALLET_PK, true);
            return feeAccount;
        });
    }
    /**
     * Create an instruction for config
     */
    createConfigInstruction(optionExpiration, subscriptionPeriodEnd, numTokens, lotSize, name, authority, baseMint, baseAccount, quoteMint, quoteAccount, soAuthority, issueAuthority) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.state(name, baseMint);
            const baseVault = yield this.baseVault(name, baseMint);
            return this.program.instruction.configV2(new anchor_1.BN(optionExpiration), new anchor_1.BN(subscriptionPeriodEnd), numTokens, lotSize, name, {
                accounts: {
                    authority,
                    soAuthority: soAuthority || authority,
                    issueAuthority: issueAuthority || authority,
                    state,
                    baseVault,
                    baseAccount,
                    quoteAccount,
                    baseMint,
                    quoteMint,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                },
            });
        });
    }
    /**
     * Create an instruction for init strike
     */
    createInitStrikeInstruction(strike, name, authority, baseMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.state(name, baseMint);
            const optionMint = yield this.soMint(strike, name, baseMint);
            return this.program.instruction.initStrike(strike, {
                accounts: {
                    authority,
                    state,
                    optionMint,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                },
            });
        });
    }
    /**
     * Create an instruction for naming a token. To be called after initStrike.
     */
    createNameTokenInstruction(strike, name, authority, baseMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.state(name, baseMint);
            const optionMint = yield this.soMint(strike, name, baseMint);
            const metaplexId = new web3_js_1.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');
            const [optionMintMetadataAccount, _optionMintMetadataBump] = (yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('metadata')),
                metaplexId.toBuffer(),
                optionMint.toBuffer(),
            ], metaplexId));
            return this.program.instruction.nameToken(strike, {
                accounts: {
                    authority,
                    payer: authority,
                    state,
                    optionMint,
                    optionMintMetadataAccount,
                    tokenMetadataProgram: metaplexId,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                },
            });
        });
    }
    /**
     * Create an instruction for issue
     */
    createIssueInstruction(amount, strike, name, authority, baseMint, userSoAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.state(name, baseMint);
            const optionMint = yield this.soMint(strike, name, baseMint);
            return this.program.instruction.issue(amount, strike, {
                accounts: {
                    authority,
                    state,
                    optionMint,
                    userSoAccount,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                },
            });
        });
    }
    /**
     * Create an instruction for add tokens
     */
    createAddTokensInstruction(amount, name, authority, baseAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseAccountData = yield (0, spl_token_1.getAccount)(this.connection, baseAccount, 'single');
            const baseMint = baseAccountData.mint;
            const state = yield this.state(name, baseMint);
            const baseVault = yield this.baseVault(name, baseMint);
            return this.program.instruction.addTokens(amount, {
                accounts: {
                    authority,
                    state,
                    baseVault,
                    baseAccount,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                },
            });
        });
    }
    /**
     * Create an instruction for exercise
     */
    createExerciseInstruction(amount, strike, name, authority, userSoAccount, userQuoteAccount, userBaseAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseAccountData = yield (0, spl_token_1.getAccount)(this.connection, userBaseAccount, 'single');
            const baseMint = baseAccountData.mint;
            const state = yield this.state(name, baseMint);
            const stateObj = yield this.getState(name, baseMint);
            const optionMint = (yield (0, spl_token_1.getAccount)(this.connection, userSoAccount, 'single')).mint;
            const baseVault = yield this.baseVault(name, baseMint);
            const { quoteAccount } = stateObj;
            const { quoteMint } = stateObj;
            const feeQuoteAccount = yield StakingOptions.getFeeAccount(quoteMint);
            return this.program.instruction.exercise(amount, strike, {
                accounts: {
                    authority,
                    state,
                    userSoAccount,
                    optionMint,
                    userQuoteAccount,
                    projectQuoteAccount: quoteAccount,
                    feeQuoteAccount,
                    baseVault,
                    userBaseAccount,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                },
            });
        });
    }
    /**
     * Create an instruction for withdraw
     */
    createWithdrawInstruction(name, authority, baseAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseAccountData = yield (0, spl_token_1.getAccount)(this.connection, baseAccount, 'single');
            const baseMint = baseAccountData.mint;
            const state = yield this.state(name, baseMint);
            const baseVault = yield this.baseVault(name, baseMint);
            return this.program.instruction.withdraw({
                accounts: {
                    authority,
                    state,
                    baseVault,
                    baseAccount,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                },
            });
        });
    }
    /**
     * Create an instruction for withdraw with the mint as a param. This is needed
     * when the recipient account is created in another instruction in this
     * transaction, so we cannot check it onchain to get the mint.
     */
    createWithdrawInstructionWithMint(name, authority, baseAccount, baseMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.state(name, baseMint);
            const baseVault = yield this.baseVault(name, baseMint);
            return this.program.instruction.withdraw({
                accounts: {
                    authority,
                    state,
                    baseVault,
                    baseAccount,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                },
            });
        });
    }
    /**
     * Return the staking options IDL.
     */
    getIdl() {
        return this.program.idl;
    }
}
exports.StakingOptions = StakingOptions;
